import angular from 'angular';
import { capitalize, includes, intersection, isEmpty, map, reject } from 'lodash';

function stringifyPrivate(poolTypes) {
  var result = '';
  if (includes(poolTypes, 'private')) {
    result = 'Private Pool';
    if (includes(poolTypes, 'private_spa')) {
      result += ' with Spa';
    }
  } else if (includes(poolTypes, 'private_spa')) {
    result = 'Private Spa';
  }
  if (result && includes(poolTypes, 'above_ground')) {
    result = 'Above Ground ' + result;
  }
  return result;
}

function stringifyCommunity(poolTypes) {
  if (includes(poolTypes, 'community')) {
    return 'Community Pool';
  }
  return '';
}

function stringifyShort(poolTypes) {
  var pools = intersection(poolTypes, ['private','community']);
  if (pools.length) {
    return map(pools, capitalize).sort().reverse().join(' and ');
  }
  if (includes(poolTypes, 'private_spa')) {
    return 'Spa only';
  }
  return 'None';
}

// Turns the pooltype array into a string
module.exports = angular.module('common.filters.stringify-pool-types', [
])
.filter('stringifyPoolTypes', function() {
  return function(poolTypes, short){
    if (!poolTypes.length) {
      return 'None';
    } else {
      if (short === 'short') {
        return stringifyShort(poolTypes);
      }
      return reject([stringifyPrivate(poolTypes), stringifyCommunity(poolTypes)], isEmpty).join(' and '); // eslint-disable-line max-len
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/stringify-pool-types.js
 **/